import React from 'react';

import { IIconProps } from 'ui/CircleIconButton';
import { theme } from '../../../../../tailwind.config';

export const CrmActivityTaskItem: React.FC<IIconProps> = React.memo(
  ({ fill = theme.colors['yellow-advert'], background = theme.colors['white'] }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill={background}/>
      <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#EAE9E8"/>
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M6.1665 8.5H13.1665V9.66667H6.1665V8.5ZM6.1665 10.8333H13.1665V12H6.1665V10.8333ZM6.1665 14.3333H10.8332V13.1667H6.1665V14.3333ZM18.4165 12.5833L17.5415 11.7083L14.339 14.9167L12.5832 13.1667L11.7082 14.0417L14.339 16.6667L18.4165 12.5833Z" 
        fill={fill}
      />
    </svg>
  )
);
